import { assert } from '../../lib/assert-sidecar'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewCreateMethod } from './multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './multi/voyageMessageCrewCreate-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageCrew_crew } from './voyageCrew_crew-sidecar'
import { voyageFakeInfo } from './voyageFakeInfo-sidecar'
import type { IVoyageSystemState } from './voyageSystems'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export function onCreate(sys: IVoyageSystemState) {
  sys.frozenCrewName = voyageFakeInfo.genFakeName()
}

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 3
  d.useSystemTimer += ds
  voyageCrew_crew.setProgress(obj, d.useSystemTimer / useSystemTime)

  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    let tHere = voyageTilemap.getSafeIJ(obj)
    assert.notNil(tHere)

    let sd = tHere.system
    assert.notNil(sd)

    if (sd.ammo > 0) {
      sd.ammo--

      if (voyageWebsockets.getIsHost()) {
        let id = createId()
        voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
          crewId: id,
          type: EVoyageCrewType.Crew,
          i: tHere.i,
          j: tHere.j + 1,
          method: EVoyageCrewCreateMethod.Normal,
          team: 0,
          name: sd.frozenCrewName,
          energy: voyageCrew.maxEnergy,
        })

        // Transfer name
        // let cr = voyageCrew.findById(id)
        // assert.notNil(cr)
        // cr.name = sd.frozenCrewName || cr.name
      }
    } else {
      voyageCrew.say(obj, 'Cryo chamber is empty')
    }
  }
}
